import '@thom/folio-ui/styles/globals.css'
import '@thom/folio-ui/styles/tailwind.css'

import { RouterProvider } from '@tanstack/react-router'
import { createContainer } from '@thom/folio-ui/app/container'
import { createFolioRouter } from '@thom/folio-ui/router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ReloadPrompt } from './reload-prompt'

const router = createFolioRouter(createContainer())

const rootElement = document.getElementById('root')
if (!rootElement) {
	throw new Error('Root element #root not found')
}

createRoot(rootElement).render(
	<StrictMode>
		<RouterProvider router={router} />
		<ReloadPrompt />
	</StrictMode>,
)
